import React from 'react';

export default function TabPanel({ children, component, tab, value, ...rest }) {
  const Component = component || 'div';

  return value === tab ? <Component {...rest}>{children}</Component> : null;
}
